import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-search\"><path d=\"M9.055 1C4.616 1 1 4.616 1 9.055s3.616 8.055 8.055 8.055a8.01 8.01 0 0 0 5.07-1.805l5.45 5.45a.836.836 0 0 0 1.18 0 .825.825 0 0 0 0-1.17l-5.45-5.452a8.019 8.019 0 0 0 1.805-5.078C17.11 4.616 13.494 1 9.055 1Zm0 1.667a6.376 6.376 0 0 1 6.389 6.388 6.376 6.376 0 0 1-6.389 6.389 6.376 6.376 0 0 1-6.388-6.389 6.376 6.376 0 0 1 6.388-6.388Z\" fill=\"currentColor\" stroke=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol